// DEMO
export const HOSTNAME = process.env.REACT_APP_HOSTNAME || "https://www.esipro.cn";

// Staging
// export const HOSTNAME = "https://esipro-front.staging.nowbst.com";

export const APP_ANDROID_APK_URL = process.env.REACT_APP_ANDROID_APK_URL || (HOSTNAME + "/assets/apps/esipro.apk");
export const APP_IOS_URL = process.env.REACT_APP_IOS_URL || "https://apps.apple.com/hk/app/%E6%98%93%E7%9A%93/id6757952294?l=en-GB";

export const API_TOKEN = process.env.REACT_APP_API_TOKEN || "JXkWxYaqpvV90S-Z@sIoJxQyxS-ESI";

// Local
// export const API_ENDPOINT = "http://localhost:8098/web";

// Staging
export const API_ENDPOINT = "https://esiproapi.staging.nowbst.com/web";

// QA
// export const API_ENDPOINT = "https://esiproapi.staging.nowbst.com/web";

// Prod
// export const API_ENDPOINT = "https://esiapi.esipro.cn/web";

// IP PROD
// export const API_ENDPOINT = "http://121.40.108.10:8098/web";

// export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || "https://esiapi.esipro.cn/web";